/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"

// ASSETS
import Linkedin from '§/src/images/svg/icons/Social-linkedin.svg';
import Youtube from '§/src/images/svg/icons/Social-youtube.svg';
import Instagram from '§/src/images/svg/icons/Social-instagram.svg';
import Wechat from '§/src/images/svg/icons/Social-wechat.svg';


const SocialMenu = ( props ) => {

  const socialMenu = props.wpMenu.nodes;

  return (

    <div id="social-top" className="social-list">
      {socialMenu.map((menuItem, index) => {

        if(menuItem.cssClasses.includes('linkedin')){
          var Linkcontent = Linkedin;
        } else if(menuItem.cssClasses.includes('youtube')){
          var Linkcontent = Youtube;
        } else if(menuItem.cssClasses.includes('instagram')){
          var Linkcontent = Instagram;
        } else if(menuItem.cssClasses.includes('wechat')){
          var Linkcontent = Wechat;
        } else {
          var Linkcontent = menuItem.title;
        }

        return(
          <button type="button" className="btn btn-sm btn-link" aria-label={ menuItem.title } key={index}>
            <UniversalLink
              className="text-light"
              target="_blank"
              to={ menuItem.uri }
              activeClassName="active"
            >
              <Linkcontent></Linkcontent>
            </UniversalLink>
          </button>
        )
      })}
    </div>

  )
}

export default SocialMenu
